import { HubConnectionBuilder, HubConnectionState } from '@aspnet/signalr';
import * as signalR from '@aspnet/signalr';

class CustomHttpClient extends signalR.DefaultHttpClient {
  constructor() {
    super(console);
  }

  send(request) {
    request.headers['spa-ignore-error-handler'] = 'true';
    return super.send(request);
  }
}

// TODO: Need to implement local storage for received notifications (including bundling mechanism). See NotificationsStoreService in VenueAppUI.Notifications
//       to share data across other apps with their own receivers that have the same containerId
// FYI:  We should use a new instance because of different parameters that can be
class NotificationReceiver {

  //static notifications  - notification storage

  constructor(baseUrl, authToken) {
    this.apiEndpoint = `${baseUrl}/app/notifications/api/env/ncenter/containers`;
    this.authToken = authToken;
    this.onUpdateSubscriptions = [];
  }

  start(containerId, sinceDate, requestFilter) {
    this.stop(); // when restart (if params changed)
    this.containerId = containerId;
    this.sinceDate = sinceDate || new Date();
    this.requestFilter = requestFilter;
    this.getHubConnectionAccess(
      this.onHubConnectionAccessSuccess.bind(this),
      err => console.error(err)
    );
  }

  stop(unsubscribeFromEvents) {
    if (unsubscribeFromEvents) {
      this.onUpdateSubscriptions = [];
    }
    if (this.connection) {
      this.connection.off('newNotification', this.onNewNotification.bind(this));
      if (this.connection.state === HubConnectionState.Connected) {
        this.connection.stop();
        this.connection = null;
      }
    }
  }

  setFilter(requestFilter) {
    throw new Error('is not implemented');
  }

  subscribeOnUpdate(callback) {
    if (callback) {
      this.onUpdateSubscriptions.push(callback);
    }
  }

  unsubscribeFromUpdate(callback = null) {
    if (callback) {
      const index = this.onUpdateSubscriptions.indexOf(callback);
      this.onUpdateSubscriptions.splice(index, 1);
    } else {
      this.onUpdateSubscriptions = [];
    }
  }

  onHubConnectionAccessSuccess(credentials) {
    this.connection = new HubConnectionBuilder()
      .withUrl(credentials.url, {
        accessTokenFactory: () => credentials.accessToken,
        httpClient: new CustomHttpClient()
      })
      .build();

    this.connection.on('newNotification', this.onNewNotification.bind(this));

    this.connection
      .start()
      .then(() => console.log('Connection started'))
      .catch(err => {
        console.log(`Error while starting connection: ${err}`);
        this.pollNotifications();
      });
  }

  onNewNotification(newNotification) {
    this.onNewNotifications([newNotification]);
  }

  onNewNotifications(newNotifications) {
    // TODO: use stream instead when we migrate root-ui to typescript
    this.onUpdateSubscriptions.forEach(s => s(newNotifications));
  }

  pollNotifications() {
    const interval = 2000;
    this.getNotificationsPoll(
      notifications => {
        this.onPollNotification(notifications);
        setTimeout(() => this.pollNotifications(), this.generateRandomValueBetween(interval, interval * 2));
      },
      err => console.error(err)
    );
  }

  // TODO: Move into helper
  generateRandomValueBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  onPollNotification(notifications) {
    if (notifications.length > 0) {
      this.updateDateSince(notifications);
      this.onNewNotifications(notifications);
    }
  }

  updateDateSince(notifications) {
    this.sinceDate = notifications.length > 0
      ? this.getLatestNotificationDate(notifications).setUTCMilliseconds(1)
      : getStartOfDate();
  }

  getLatestNotificationDate(notifications) {
    return notifications && notifications.length
      ? new Date(notifications.sort((a, b) => (a.dateOfLastUpdate > b.dateOfLastUpdate ? 1 : -1))[0].dateOfLastUpdate)
      : null;
  }

  // TODO: Move into helper
  getStartOfDate() {
    return new Date(new Date().setUTCHours(0, 0, 0, 0));
  }

  getAuthBearerTokenOrDefault() {
    return this.authToken && `Bearer ${this.authToken}`;
  }

  getNotificationsPoll(onSuccess, onError) {
    fetch(`${this.apiEndpoint}/${this.containerId}/poll?since=${this.sinceDate.toISOString()}`, {
        headers: {
          Authorization: this.getAuthBearerTokenOrDefault()
        }
      })
      .then(response => response.json())
      .then(onSuccess)
      .catch(onError);
  }

  getHubConnectionAccess(onSuccess, onError) {
    fetch(`${this.apiEndpoint}/${this.containerId}/negotiate`, {
        headers: {
          'x-ms-client-principal-id': this.containerId,
          Authorization: this.getAuthBearerTokenOrDefault()
        }
      })
      .then(response => response.json())
      .then(onSuccess)
      .catch(onError);
  }
}

export class NotificationReceiverFactory {
  static create(baseUrl, authToken) {
    return new NotificationReceiver(baseUrl, authToken);
  }
}